import React, { Component } from "react";

class StartLearningBttn extends Component {
  render() {
    return (
      <div
        style={{
          padding: "0px",
          border: "0px",
          backgroundColor: "#17D9AA",
          borderRadius: "5px",
          outline: "none",
          width: "178px",
          height: "36px",
          color: "#232D43",
          fontSize: "12px",
          fontFamily: "Helvetica",
          fontStyle: "normal",
          fontWeight: "300",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <p id='startLearning'>Start Learning</p>
      </div>
    );
  }
}

export default StartLearningBttn;
